import type { ProjectionAnalysis } from '../../../types/ProjectionAnalysis';
import type { RootState } from '../../store';

export const getScenarioAnalysisScenarioProjectionData = (state: RootState): ProjectionAnalysis =>
  state.scenarioAnalysis.projectedRevenue.scenarioTable;

export const getScenarioAnalysisActualProjectionData = (state: RootState): ProjectionAnalysis =>
  state.scenarioAnalysis.projectedRevenue.actualTable;

export const getScenarioAnalysisProjectionDataSettings = (state: RootState) =>
  state.scenarioAnalysis.projectedRevenue.settings;
